import React, { Component, lazy } from 'react';
import { injectIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import HUBContext from '../../../../services/HUBContext';
import { Icon } from 'antd';

const Link = lazy(() => import('@material-ui/core/Link'));
const Tooltip = lazy(() => import('@material-ui/core/Tooltip'));
const LinkRouter = props => <Link {...props} component={RouterLink} className="link" />

class IndicatorSimpleCircle extends Component {
    /*
        data object structure
        data = {
            uid: "sd12sks",
            datasets: { currentValue: 0, beforeValue: 0 }
        }
        https://www.chartjs.org/docs/master/general/data-structures.html
    */

    defaultObject = {
        itemType: 'v2-indicator-simple-circle',
        groups: ['companyID'],
        measure: 'vehicleID:count-distinct',
        filters: [],
        title: '-',
        //title: { key: 'activeVehicles', text: 'Active vehicles' },
        tooltip: '',
        //tooltip: { key: '', text: '....'}
        visible: true,
        prefix: '',
        sufix: '',
        autocompare: false,
        colorRules: [],
        //colorRules: [
        //    { color: '', backgroundColor: 'var(--pink-light)', rule: 'variation > 0' },
        //    { color: '', backgroundColor: 'var(--olive-light)', rule: 'variation < 0' }
        //]
        //to: '/app/:cid/dash/:did/drivers?status=active&startDate=:startDate&endDate=:endDate&dashboardKey=Drivers',
        to: null,
        numberFormat: {
            style: 'decimal',
            useGrouping: true,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        },
        checked: false,
        onClick: null
    };

    valueFormat = {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }

    percentFormat = {
        style: 'percent',
        useGrouping: true,
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }
    
    render() {
        const { widget, intl, data, showSettings, settingsControl, className } = this.props;
        const { company, dashboards } = this.context;
        const datasets = data?.parse?.datasets || { currentValue: 0, beforeValue: 0 };
        
        //Complement settings
        const config = {...JSON.parse(JSON.stringify(this.defaultObject)), ...widget };
        
        let title = '';
        if (typeof(config.title || '') === 'string') title = config.title || '';
        else if (!!config.title.key)
            title = intl.formatMessage({ id: config.title.key || '', defaultMessage: config.title.text || '' });

        let tooltip = '';
        if (typeof(config.tooltip || '') === 'string') tooltip = config.tooltip;
        else if (!!config.tooltip.key)
            tooltip = intl.formatMessage({ id: config.tooltip.key || '', defaultMessage: config.tooltip.text || '' });

        const prefix = !!config.prefix ? `${config.prefix} ` : '';
        const sufix = config.sufix || '';
        const ruleStyle = {
            color: 'var(--black-txt)',
            backgroundColor: 'var(--grey-10)',
            borderColor: 'var(--grey-10)'
        };

        let redirectUrl = null;
        if (!!config.to && config.to !== '') {
            let urlSPlit = config.to.split('?');

            //Route params
            urlSPlit[0] = urlSPlit[0].replace(':cid', company?.companyID || 0);
            if (urlSPlit.length > 1) {
                const urlParams = new URLSearchParams(urlSPlit[1]);
                const dashboardKey = urlParams.get('dashboardKey') || '*';
                const dashboard = (dashboards || []).find(x => x.dashboardKey === dashboardKey);
                urlSPlit[0] = urlSPlit[0].replace(':did', dashboard?.dashboardID || 0);
            }

            //SearchParams
            (data.parameters || []).map(param =>  {
                urlSPlit[1] = urlSPlit[1].replace(`:${param.key}`, param.value);
            });
            
            redirectUrl = `${urlSPlit[0]}?${urlSPlit[1]}`;
        }
       
        const autocompare = !!config.autocompare;
        const value = datasets?.currentValue || 0;
        const oldValue = autocompare ? (datasets?.beforeValue || 0) : value;
        const variation = value - oldValue;
        const direction = variation > 0 ? 'up' : 'down';
        const percent = Math.abs(autocompare ? (oldValue === 0 ? (value !== 0 ? 1 : 0) : variation / oldValue) : 0);

        (config.colorRules || []).forEach(cr => {
            const rule = (cr.rule || 'variation != variation').split(' ');
            if (rule.length !== 3) return;

            const compareA = rule[0] === 'variation' ? variation : value;
            const compareB = rule[2] === 'variation' ? variation : rule[2] === 'value' ? value : 0;
            const operator = rule[1] || '==';
            let apply = false;
            switch (operator) {
                case '>': apply = compareA > compareB; break;
                case '>=': apply = compareA >= compareB; break;
                case '<': apply = compareA < compareB; break;
                case '<=': apply = compareA <= compareB; break;
                default: apply = compareA === compareB;
            }
            if (apply) {
                ruleStyle.color = cr.color || 'var(--black)';
                ruleStyle.backgroundColor = cr.backgroundColor || 'var(--grey-10)';
                ruleStyle.borderColor = cr.color || 'var(--grey-10)';
            }
        });

        const valueFormatObject = { ...this.valueFormat, ...(config.numberFormat || {}), currency: company?.currencyID }
        const variationSpanFormat = {  backgroundColor: autocompare ? ruleStyle.backgroundColor : 'transparent' };
        if (!autocompare) variationSpanFormat.color = 'transparent';

        return <div className={`indicator-simple-circle ${className || ''}`} style={{ borderColor: ruleStyle.borderColor }} id={`chart-${widget?._uid}`}>
                    <div className={`external-ring ${!!config.onClick ? 'selectable' : ''}`}>
                        <div className={`internal-ring ${!!config.onClick ? 'selectable' : ''}`} onClick={() => { if (!!config.onClick) config.onClick(); }}>
                            {
                                !!tooltip && <Tooltip placement='top' title={tooltip}>
                                    <span className="value" style={{ color: ruleStyle.color }}>{`${prefix}${intl.formatNumber(value, valueFormatObject)}${sufix}`}</span>
                                </Tooltip>
                            }
                            {
                                !tooltip && <span className="value" style={{ color: ruleStyle.color }}>{`${prefix}${intl.formatNumber(value, valueFormatObject)}${sufix}`}</span>
                            }
                        </div>
                    </div>
                    <div className="title">
                        <span>
                            { !!config.checked && <Icon type="check" /> }
                            { title  }
                        </span>
                    </div>
                </div>
    }
}

IndicatorSimpleCircle.contextType = HUBContext
IndicatorSimpleCircle = injectIntl(IndicatorSimpleCircle);
export default IndicatorSimpleCircle;